export default "__VITE_ASSET__DpPs2O1x__"